import React from 'react';
import { Box } from 'vindi-ds-components';

import {
  PrFileText,
  PrEdit3,
  PrCalendar,
  PrUsers,
  PrAlertTriangle,
  PrGitPullRequest,
} from 'vindi-ds-icons/pr';

import ReportCard from './reportCard';
import templates from '../template/templates.json';

const singleReportParams = [
  {
    icon: <PrFileText />,
    name: templates.invoices.name,
    links: templates.invoices.links,
  },
  {
    icon: <PrEdit3 />,
    name: templates.subscriptions.name,
    links: templates.subscriptions.links,
  },
  {
    icon: <PrCalendar />,
    name: templates.unbilled_periods.name,
    links: templates.unbilled_periods.links,
  },
  {
    icon: <PrUsers />,
    name: templates.payment_profiles.name,
    links: templates.payment_profiles.links,
  },
  {
    icon: <PrAlertTriangle />,
    name: templates.contact_logs.name,
    links: templates.contact_logs.links,
  },
  {
    icon: <PrGitPullRequest />,
    name: templates.integration_logs.name,
    links: templates.integration_logs.links,
  },
];

function SingleLinkReports() {
  return (
    <Box>
      {singleReportParams.map((singleReport) => (
        <ReportCard
          key={singleReport.name}
          icon={singleReport.icon}
          name={singleReport.name}
          links={singleReport.links}
          marginCard={2}
          heightCard='4.5em'
        />
      ))}
    </Box>
  );
}

export default SingleLinkReports;
